<template>
  <div>
    <div v-if="!clients" class="alert alert-info text-center">
      Sélectionnez des filtres et cliquez sur "Visualiser" pour afficher les
      clients.
    </div>

    <el-table
      v-else
      ref="table"
      :data="clients"
      :default-sort="sorting"
      style="width: 100%; max-width: 100%; overflow-x: auto"
      @sort-change="sortChange"
      @row-click="goToClient"
    >
      <el-table-column width="40" align="center" fixed="left">
        <template slot-scope="scope">
          <template v-if="scope.row.conversion">
            <i
              v-if="scope.row.conversion.rank === 'lost'"
              class="text-danger fa fa-exclamation-circle"
            />
            <i
              v-else-if="scope.row.conversion.rank !== 'pending'"
              class="text-success fa fa-check-circle"
            />
          </template>
          <template v-if="scope.row.urssafInscription">
            <i
              v-if="
                !scope.row.urssafInscription.idClient &&
                scope.row.urssafInscription.status === 'pending'
              "
              class="fa fa-balance-scale text-danger"
              aria-hidden="true"
            ></i>
            <i
              v-else-if="scope.row.urssafInscription.idClient"
              class="fa fa-balance-scale text-success"
              aria-hidden="true"
            ></i>
            <i
              v-else-if="
                !scope.row.urssafInscription.idClient &&
                scope.row.urssafInscription.status === 'send'
              "
              class="fa fa-balance-scale text-warning"
              aria-hidden="true"
            ></i>
          </template>
        </template>
      </el-table-column>
      <el-table-column
        label="Nom"
        prop="lastName"
        sortable="custom"
        min-width="100"
        fixed="left"
      >
      </el-table-column>
      <el-table-column
        label="Prénom"
        prop="firstName"
        sortable="custom"
        min-width="100"
        fixed="left"
      >
      </el-table-column>
      <el-table-column
        label="Société"
        prop="company"
        sortable="custom"
        min-width="100"
      >
      </el-table-column>
      <el-table-column
        label="CP"
        prop="zipcode"
        sortable="custom"
        width="80"
      ></el-table-column>
      <el-table-column
        label="Ville"
        prop="city"
        sortable="custom"
        min-width="180"
      ></el-table-column>
      <el-table-column
        label="Créé le"
        prop="createdAt"
        sortable="custom"
        width="100"
      >
        <template slot-scope="scope">
          {{ formatDateTime(scope.row.createdAt) }}
          <small
            v-if="scope.row.inactiveSince"
            class="d-block font-weight-bold"
          >
            Inactif depuis le {{ formatDateTime(scope.row.inactiveSince) }}
          </small>
        </template>
      </el-table-column>
      <el-table-column label="B2B" prop="isB2B" width="60" align="center">
        <template slot-scope="scope">
          <i v-if="scope.row.isB2B" class="fa fa-check-circle text-info"></i>
        </template>
      </el-table-column>
      <el-table-column label="Commercial" prop="commercials" min-width="160">
        <template slot-scope="scope">
          <CommercialRel
            v-for="commercialRel in scope.row.commercials"
            :key="commercialRel.id"
            :relation="commercialRel"
          />
        </template>
      </el-table-column>
      <el-table-column label="Coachs" prop="coachs" min-width="140">
        <template slot-scope="scope">
          <small
            v-for="coach in scope.row.coachs"
            :key="coach.id"
            class="d-block"
          >
            {{ coach.coach.name }}</small
          >
        </template>
      </el-table-column>
      <el-table-column label="Note" prop="commercialNotes" min-width="210">
        <template slot-scope="scope">
          <NoteModal
            :notes="scope.row.commercialNotes"
            @showComment="$emit('showComment', scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column
        v-if="hasPermission($store.state.user, 'CLIENTS_WRITE')"
        label="Archives"
        width="90"
        align="center"
      >
        <template slot-scope="scope">
          <button
            v-if="!scope.row.archived"
            class="btn btn-sm btn-info"
            @click.stop="$emit('archiveClient', scope.row)"
          >
            <i class="fa fa-briefcase"></i>
          </button>
          <i v-else class="fa fa-briefcase text-muted"></i>
        </template>
      </el-table-column>
    </el-table>

    <paginate
      ref="paginate"
      :value="page"
      :page-count="count"
      :click-handler="paginationHandler"
      prev-text="Précédent"
      next-text="Suivant"
      container-class="pagination"
      class="mt-1"
    ></paginate>
  </div>
</template>

<script>
import Paginate from "vuejs-paginate";

import { mapState } from "vuex";
import FrequencyMixin from "@/mixin/FrequencyMixin";
import NoteModal from "@/components/form/NoteModal";
import CommercialRel from "@/components/utils/CommercialRel";

export default {
  components: {
    Paginate,
    NoteModal,
    CommercialRel,
  },
  mixins: [FrequencyMixin],
  props: {
    clients: {
      type: Array,
      default: null,
    },
    page: {
      type: Number,
      required: true,
    },
    rows: {
      type: Number,
      default: 20,
    },
    totalClients: {
      type: Number,
      default: 0,
    },
    sorting: {
      type: Object,
      default: () => ({ prop: "createdAt", order: "descending" }),
    },
  },
  data() {
    return {
      displayArchived: false,
    };
  },
  computed: {
    count() {
      const count = this.displayArchived
        ? this.totalArchived
        : this.totalClients;

      return Math.ceil(count / this.rows);
    },
    ...mapState({
      concepts: (state) => state.concepts,
    }),
  },
  watch: {
    page() {
      this.$refs.paginate.selected = this.page - 1;
    },
  },
  methods: {
    sortChange({ prop, order }) {
      this.$emit("sort", { prop, order });
    },

    paginationHandler(page) {
      this.$emit("changePage", page);
    },

    clientConcepts(client) {
      let data = [];
      if (client.orders) {
        let concepts = {};
        client.orders.forEach((o) => {
          concepts[o.concept] = concepts[o.concept] || 0;
          concepts[o.concept]++;
        });
        for (let name in concepts) {
          if (Object.prototype.hasOwnProperty.call(concepts, name)) {
            data.push(
              (this.conceptLogo(name, this.concepts) || "") +
                " (" +
                concepts[name] +
                ") ",
            );
          }
        }
      }
      return data;
    },

    goToClient(client) {
      const route = this.$router.resolve({
        name: "client-details",
        params: {
          id: client.id,
        },
      });

      window.open(route.href, "_blank");
    },

    active(client) {
      let sessions = 0;
      let completed = 0;

      if (client.orders) {
        client.orders.forEach((order) => {
          if (order.completed) {
            return;
          }
          sessions += order.session;
          completed += order.sessions.filter((s) => s.completed).length;
        });
        if (sessions !== completed) {
          return completed + "/" + sessions;
        }
      }
    },
  },
};
</script>

<style scope>
.user-link {
  color: #20a8d8;
}

.el-table__row {
  cursor: pointer;
}

.sort-caret.ascending.active {
  border-bottom-color: #20a8d8;
}

.sort-caret.descending.active {
  border-top-color: #20a8d8;
}
</style>
